import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { CheckCircle2, ArrowRight, Award } from 'lucide-react';

const REASONS = [
  'Transparent, predictable monthly pricing',
  'No long-term contracts required',
  'Local team with enterprise expertise',
  'Proactive monitoring prevents issues',
  'Dedicated account manager',
  'Same-day emergency response',
];

export function WhyChooseUs() {
  return (
    <section className="py-24 gradient-mesh relative" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-6" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Why SMBs Choose <span className="text-blue-600">MLC TECH</span>
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Tired of overpriced IT vendors and surprise bills? We built MLC TECH
              specifically for small and medium businesses who deserve enterprise-level
              support without the enterprise price tag.
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              {REASONS.map((item) => (
                <div key={item} className="flex items-start gap-3 p-3 rounded-lg hover:bg-white/60 transition-colors">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="mt-10">
              <Link to="/about">
                <Button variant="outline" className="border-slate-300 hover:border-blue-500 hover:text-blue-600 btn-hover-lift" data-testid="learn-more-btn">
                  Learn More About Us <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
              alt="MLC TECH Team"
              className="rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <Award className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <div className="font-bold text-slate-900">Certified Experts</div>
                  <div className="text-sm text-slate-600">Microsoft & Cisco Partners</div>
                </div>
              </div>
            </div>
            <img
              src="/mlctech-logo.png"
              alt=""
              className="absolute -top-4 -right-4 h-16 w-auto animate-float-delayed opacity-20 hidden lg:block"
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
